import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { useAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";

export default function Signin() {
  const { signin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mfaNeeded, setMfaNeeded] = useState(false);
  const [mfa, setMfa] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await signin(email, password, mfaNeeded ? mfa : null);
      toast.success("Signed in.");
      nav("/app");
    } catch (e) {
      const code = e?.problem?.code;
      if (code === "MFA_REQUIRED") { setMfaNeeded(true); setErr("Enter the 6-digit code from your authenticator app."); }
      else setErr(e?.problem?.detail || e?.problem?.title || e.message);
    } finally { setBusy(false); }
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto avcp-card p-8">
        <h1 className="text-3xl">Sign in</h1>
        <form onSubmit={submit} data-testid={TID.signinForm} className="mt-6 grid gap-4">
          <label className="grid gap-1.5">
            <span className="text-sm font-medium">Email</span>
            <input data-testid={TID.signinEmail} className="avcp-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="grid gap-1.5">
            <span className="text-sm font-medium">Password</span>
            <input data-testid={TID.signinPassword} className="avcp-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} />
          </label>
          {mfaNeeded && (
            <label className="grid gap-1.5">
              <span className="text-sm font-medium">Authenticator code</span>
              <input data-testid={TID.signinMfa} className="avcp-input font-mono" inputMode="numeric"
                maxLength={6} value={mfa} onChange={(e) => setMfa(e.target.value)} />
            </label>
          )}
          {err && <div className="text-sm text-[var(--avcp-danger)]">{err}</div>}
          <button data-testid={TID.signinSubmit} className="avcp-btn primary" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 flex items-center justify-between text-sm">
          <Link className="avcp-link" to="/forgot">Forgot password?</Link>
          <Link className="avcp-link" to="/signup">Create an account</Link>
        </div>
      </div>
    </Layout>
  );
}
